module.exports = __webpack_public_path__ + "./fonts/SFUIText-Light.otf";